import React from "react";
import { PlayCircleOutlined } from "@ant-design/icons";

const VideoPreviewThumbnail = ({
  url,
  title = "Video",
  onClick,
  maxWidth = 280,
  maxHeight = 180,
}) => (
  <div
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onClick?.();
      }
    }}
    title={title}
    style={{
      position: "relative",
      cursor: "pointer",
      maxWidth,
      width: maxWidth === "100%" ? "100%" : undefined,
      height: maxWidth === "100%" ? "100%" : undefined,
      borderRadius: maxWidth === "100%" ? 0 : "8px",
      overflow: "hidden",
      background: "#000",
    }}
  >
    <video
      src={url}
      preload="metadata"
      muted
      playsInline
      style={{
        width: "100%",
        height: maxWidth === "100%" ? "100%" : undefined,
        maxHeight: maxWidth === "100%" ? undefined : maxHeight,
        minHeight: maxWidth === "100%" ? 120 : undefined,
        display: "block",
        objectFit: "cover",
        pointerEvents: "none",
      }}
    />
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0, 0, 0, 0.28)",
      }}
    >
      <PlayCircleOutlined style={{ fontSize: 48, color: "#fff" }} />
    </div>
  </div>
);

export default VideoPreviewThumbnail;
